export default "__VITE_ASSET__BZiurTMW__"